import EditProfileContainer from "../../Component/AccountSettings/EditProfile/EditProfile"

const EditProfile = () => {
  return (
    <div className='page-body'>
      <EditProfileContainer />
    </div>
  )
}

export default EditProfile